import React from 'react';
import { EvaluationResult as EvaluationResultType } from '../../../../../../redux/api/questionsApi';
import {
  ResultContainer,
  ResultHeader,
  ResultTitle,
  ResultAnswer,
  ResultScore,
  ResultFeedback,
} from './styles';
import { getScoreClass } from '../../utils/utils';
import { MESSAGES } from '../../utils/constants';

interface EvaluationResultProps {
  evaluationResult: EvaluationResultType;
  answer: string;
  isEvaluating: boolean;
}

export const EvaluationResult: React.FC<EvaluationResultProps> = ({
  evaluationResult,
  answer,
  isEvaluating,
}) => {
  if (isEvaluating) return null;

  const scoreClass = getScoreClass(evaluationResult.score);

  return (
    <>
      <ResultContainer className={scoreClass}>
        <ResultHeader>
          <ResultTitle>{MESSAGES.YOUR_ANSWER}</ResultTitle>
        </ResultHeader>
        <ResultAnswer>{answer || MESSAGES.NO_ANSWER}</ResultAnswer>
        <ResultScore className={scoreClass}>
          {evaluationResult.score} / {evaluationResult.maxScore}
        </ResultScore>
      </ResultContainer>
      <ResultFeedback>{evaluationResult.feedback}</ResultFeedback>
    </>
  );
};
